import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "common-form-component" }
const _hoisted_2 = { class: "el-form-item__label custom-label" }

import { onMounted, reactive, ref, toRefs, onBeforeMount, watch, nextTick } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { BaseObject } from '@/types/index'
// import FileUpload from './FileUpload.vue'
// import { findValueBySetCode } from '@/api/common'

// el-select options 选项类型
interface OptionItem {
  label?: string
  value?: any
  [index: string]: any
}
// el-option label/value 使用其他字段名的映射
interface OptionItemKeysMap {
  label: string
  value: string
}

// el-form-item 数据类型
interface FormItem {
  type: '10' | '11' | '20' | '21' | '22' | '30' | '40' | '50' | '60' | '70' | '80' // 10:el-input, 11:el-input.textarea, 20:el-date-picker, 30:el-select, 50:el-autocomplete,  70:单选框, 80:文件上传
  label: string // 表单项 label
  prop: string // 表单项 prop
  clearable?: boolean // 表单项 是否可清除，默认 true
  options?: OptionItem[] // 表单项是el-select且选项是值集时，查询到的选项列表，接口数据结构 [{value:'', name:''}]
  valueSetCode?: string // 表单项是el-select且选项是值集时，查询值集的code
  optionItemKeysMap?: OptionItemKeysMap // 表单项是el-select且选项非值集时，<el-option>使用的属性的映射
  slotName?: string // 插槽名，有值即表示使用插槽
  disabled?: boolean // 是否禁用
  readonly?: boolean // 是否只读
  elColSpan?: number // el-form-item :span的值
  showAllLevels?: boolean // 表单项是el-cascader时，show-all-levels
  queryFetch?: (queryString: string, cb: any) => void // 表单项是el-autocomplete时，fetch-suggestions
  maxLength?: number
  showWordLimit?: boolean
  labelDesc?: string //el-form-item label 描述信息
  buttonText?: string //80上传组件，按钮文字
  rows?: number //11textarea
}
// 如何定义PropsValue的对象类型，使包含所有propsList的prop，运行时确定propsList，无法校验？？？TODO
// interface PropsValue<T extends FormItem> {
//   [p in keyof T]:any
// }
// props的类型声明、默认值。（vue3要求，类型声明参数：类型字面量；在同一文件中的接口或类型字面量的引用）

export default /*@__PURE__*/_defineComponent({
  __name: 'CommonForm',
  props: {
    propsList: { default: () => [] },
    propsValue: { default: () => ({}) },
    labelWidth: { default: 'auto' },
    elColSpan: { default: 6 },
    showLable: { type: Boolean, default: true },
    rules: {},
    btnPlacement: { default: 'left' }
  },
  emits: ['cancel', 'confirm'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
// let formData = toRefs(props.propsValue) //defineProps声明的属性，不可修改，vue已设置为readonly，但是props.key.key可修改。propsValue是在父组件声明的reactive数据，传入子组件保持响应式
let formData = props.propsValue //formRef.value?.validate校验的值是原始reactive值，toRefs包括后无法校验

const emit = __emit //emit 第一个参数被vue定义为defineEmits的联合类型

const formRef = ref<FormInstance>()

// 重置表单
const resetFields = () => {
  formRef.value?.resetFields()
}
// 清空输入校验
const clearValidate = () => {
  formRef.value?.clearValidate()
}
// 向父组件暴露当前住组件的方法
__expose({
  resetFields,
  clearValidate,
})

// 80 文件上传 为各个表单项组件设置ref
let refMap = reactive<BaseObject>({})
const setRef = (el, item) => {
  refMap[item.prop] = el
}

// 取消按钮
const handleCancel = () => {
  emit('cancel')
  clearValidate()
}

// 保存按钮
const handleSave = () => {
  formRef.value?.validate(valid => {
    if (valid) {
      nextTick(async () => {
        await refMap.file?.confirmUpload() //默认当前只注册了一个上传组件，且表单项prop值是file TODO
        emit('confirm', formData)
      })
    } else {
      // ElMessage.error('请检查输入')
    }
  })
}

// 上传组件80：文件上传成功回调
const uploadSuccessCB = (data: any) => {
  console.log('uploadSuccessCB')
  formData.file = data || {}
}

onBeforeMount(() => {
  // 数据字典：el-select 选项值集，默认数据结构[{name:'',value:''}]。后端暂无相应接口 TODO
  // props.propsList.map(item => {
  //   if (item.valueSetCode) {
  //     findValueBySetCode({ valueSetCode: item.valueSetCode })
  //       .then((response: any) => {
  //         if (response.statusCode == 200) {
  //           item.options = response.responseData
  //         }
  //       })
  //       .catch(error => {
  //         console.log('CommonForm-findValueBySetCode-error', error)
  //       })
  //   }
  // })
})
onMounted(() => {})

return (_ctx: any,_cache: any) => {
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      model: _unref(formData),
      rules: props.rules,
      "label-position": "top"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.propsList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "edit-form-item",
            key: item.prop
          }, [
            _createVNode(_component_el_form_item, {
              class: "item-style",
              "label-width": props.labelWidth,
              label: props.showLable ? item.label : '',
              prop: item.prop
            }, _createSlots({
              default: _withCtx(() => [
                (item.slotName)
                  ? _renderSlot(_ctx.$slots, item.slotName, {
                      key: 0,
                      prop: item
                    })
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (item.type == '10')
                        ? (_openBlock(), _createBlock(_component_el_input, {
                            key: 0,
                            modelValue: _unref(formData)[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_unref(formData)[item.prop]) = $event),
                            placeholder: '请输入' + item.label,
                            clearable: 'clearable' in item ? !!item.clearable : true,
                            disabled: 'disabled' in item ? !!item.disabled : false,
                            readonly: 'readonly' in item ? !!item.readonly : false,
                            maxlength: item.maxLength ?? 100
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "clearable", "disabled", "readonly", "maxlength"]))
                        : _createCommentVNode("", true),
                      (item.type == '11')
                        ? (_openBlock(), _createBlock(_component_el_input, {
                            key: 1,
                            type: "textarea",
                            modelValue: _unref(formData)[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_unref(formData)[item.prop]) = $event),
                            placeholder: '请输入' + item.label,
                            clearable: 'clearable' in item ? !!item.clearable : true,
                            disabled: 'disabled' in item ? !!item.disabled : false,
                            "show-word-limit": !!(item.showWordLimit ?? (item.maxLength ? true : false)),
                            maxlength: item.maxLength
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "clearable", "disabled", "show-word-limit", "maxlength"]))
                        : _createCommentVNode("", true),
                      (item.type == '20')
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 2,
                            type: "daterange",
                            modelValue: _unref(formData)[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_unref(formData)[item.prop]) = $event),
                            "value-format": "YYYY-MM-DD",
                            "start-placeholder": "开始时间",
                            "end-placeholder": "结束时间",
                            clearable: 'clearable' in item ? !!item.clearable : true,
                            disabled: 'disabled' in item ? !!item.disabled : false
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "clearable", "disabled"]))
                        : _createCommentVNode("", true),
                      (item.type == '21')
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 3,
                            type: "datetime",
                            modelValue: _unref(formData)[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_unref(formData)[item.prop]) = $event),
                            "value-format": "YYYY-MM-DD HH:mm:ss",
                            clearable: 'clearable' in item ? !!item.clearable : true,
                            disabled: 'disabled' in item ? !!item.disabled : false
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "clearable", "disabled"]))
                        : _createCommentVNode("", true),
                      (item.type == '22')
                        ? (_openBlock(), _createBlock(_component_el_date_picker, {
                            key: 4,
                            type: "date",
                            modelValue: _unref(formData)[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_unref(formData)[item.prop]) = $event),
                            "value-format": "YYYY-MM-DD",
                            clearable: 'clearable' in item ? !!item.clearable : true,
                            disabled: 'disabled' in item ? !!item.disabled : false
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "clearable", "disabled"]))
                        : _createCommentVNode("", true),
                      (item.type == '30')
                        ? (_openBlock(), _createBlock(_component_el_select, {
                            key: 5,
                            modelValue: _unref(formData)[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_unref(formData)[item.prop]) = $event),
                            placeholder: '请选择' + item.label,
                            clearable: 'clearable' in item ? !!item.clearable : true,
                            disabled: 'disabled' in item ? !!item.disabled : false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (optionItem, optionItemIndex) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: optionItemIndex,
                                  label: optionItem[item?.optionItemKeysMap?.label || 'label'],
                                  value: optionItem[item?.optionItemKeysMap?.value || 'value']
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "clearable", "disabled"]))
                        : _createCommentVNode("", true),
                      (item.type == '50')
                        ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                            key: 6,
                            modelValue: _unref(formData)[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_unref(formData)[item.prop]) = $event),
                            "fetch-suggestions": item.queryFetch,
                            placeholder: '请选择' + item.label,
                            clearable: 'clearable' in item ? !!item.clearable : true,
                            disabled: 'disabled' in item ? !!item.disabled : false
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "placeholder", "clearable", "disabled"]))
                        : _createCommentVNode("", true),
                      (item.type == '70')
                        ? (_openBlock(), _createBlock(_component_el_radio_group, {
                            key: 7,
                            modelValue: _unref(formData)[item.prop],
                            "onUpdate:modelValue": ($event: any) => ((_unref(formData)[item.prop]) = $event),
                            disabled: 'disabled' in item ? !!item.disabled : false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (optionItem, optionItemIndex) => {
                                return (_openBlock(), _createBlock(_component_el_radio, {
                                  key: optionItemIndex,
                                  label: optionItem[item?.optionItemKeysMap?.value || 'value']
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(optionItem[item?.optionItemKeysMap?.label || 'label']), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]))
                        : _createCommentVNode("", true),
                      (item.type == '80')
                        ? (_openBlock(), _createBlock(_component_file_upload, {
                            key: 8,
                            ref_for: true,
                            ref: el => setRef(el, item),
                            "button-text": item.buttonText,
                            onUploadSuccess: uploadSuccessCB
                          }, null, 8, ["button-text"]))
                        : _createCommentVNode("", true)
                    ], 64))
              ]),
              _: 2
            }, [
              (item.labelDesc)
                ? {
                    name: "label",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                        _createVNode(_component_el_popover, {
                          placement: "top-start",
                          width: 300,
                          trigger: "hover",
                          content: item.labelDesc || '',
                          "popper-style": "fontSize:12px"
                        }, {
                          reference: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createVNode(_component_el_icon, { size: 15 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_QuestionFilled)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["label-width", "label", "prop"])
          ]))
        }), 128)),
        (props.btnPlacement === 'left')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['btn-block', props.btnPlacement])
            }, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "default",
                onClick: handleSave
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("保存", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "default",
                onClick: handleCancel
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              })
            ], 2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(['btn-block', props.btnPlacement])
            }, [
              _createVNode(_component_el_button, {
                size: "default",
                onClick: handleCancel
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "default",
                onClick: handleSave
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("保存", -1)
                ]))]),
                _: 1
              })
            ], 2))
      ]),
      _: 3
    }, 8, ["model", "rules"])
  ]))
}
}

})